import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
export function Reviews() {
  if (reviews.length === 0) return null;
  return <section aria-labelledby="reviews-heading" className="grid-light w-full bg-paper text-pine" data-id="element-326" data-mp="2hefbyqdgjd2p">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-327" data-mp="2raie3w8b7bpn">
        <div className="text-center" data-id="element-328" data-mp="2rc3alre6p4q5">
          <p className="eyebrow text-ember-deep" data-id="element-329" data-mp="2wa4ozz0o0fva">From the field</p>
          <h2 id="reviews-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-330" data-mp="2w7scw2hl8zq5">
            What techs are seeing on their calls
          </h2>
        </div>

        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-331" data-mp="3a1jb4epvcx6k">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-332" data-mp="3f1xkc037id66">
              <figure className="flex w-full flex-col border-t-2 border-ember pt-5" data-id="element-333" data-mp="3jz7grzp0jp3i">
                <blockquote className="text-[17px] leading-relaxed text-pine" data-id="element-334" data-mp="2rcnqfhtvmsoe">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-335" data-mp="2mcj77k1l3juh">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-mono text-sm font-bold text-paper" data-id="element-336" data-mp="2hdy85ny2j67m">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-pine-soft" data-id="element-337" data-mp="353k6yaaj3jf3">
                    <span className="block text-[14px] font-bold text-pine" data-id="element-338" data-mp="356eqlzlpx07g">
                      {review.name}
                    </span>
                    {review.role}
                    <span className="mt-0.5 flex items-center gap-1 text-pine-muted" data-id="element-339" data-mp="2wbi7ae8aa75v">
                      <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-340" data-mp="3sug1vgaa6uqk" />
                      {review.city}, {review.country}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}